<div class="flex flex-col w-full">
    <div class="bg-background w-full">
        <div class="container mx-auto text-center max-w-xl pt-6 pb-12 px-2">
            <app-explainer-text heading="Kursübersicht" id="course-overview">
                <p>
                    Hier findest du eine Übersicht aller Kurse. Klicke einen Kurs an, um deinen aktuellen Status zu
                    sehen.
                </p>
            </app-explainer-text>
        </div>
    </div>

    <div class="bg-background-dark w-full md:px-16 py-4 pl-2 overflow-x-auto overflow-y-hidden scrollbar">
        <h2 class="pb-2">Alle Kurse</h2>

        <div class="flex flex-nowrap gap-12 h-64 py-4">
            @for (course of availableCourses; track course.id) {
            @if(course.access){
            <a class="cursor-pointer" (click)="selectCourse(course.id)">
                <div class="group b-4 w-44 h-56 flex flex-col justify-between font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">

                    <div
                        class="z-40 text-center text-blue font-bold group-hover:scale-125 transition-all duration-500 ease-out">
                        <h2 class="dark:text-white mt-8"> {{ course.name }}</h2>
                    </div>
                    <div class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 shrink-0 shadow rounded border-4"
    [ngClass]="selectedCourseId === course.id ? 'border-red ' : 'opacity-50 border-white'">
    
    <div class="absolute inset-0 bg-primary-hover opacity-[15%] dark:bg-primary rounded bg-center"></div>

    <div class="relative w-full h-full flex flex-col justify-end items-center">
        <img src="./assets/img/card-images/knoot_noicon.svg" class="w-14 mb-2" alt="Course Image">
    </div>
</div>
                </div>
            </a>
            }
            @else {
            <a class="cursor-pointer" (click)="selectCourse(course.id)">
                <div 
                    class="group b-4 w-44 h-56 flex flex-col justify-between font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">
                    <div
                        class="z-40 text-center text-blue dark:text-white font-shadow font-bold group-hover:scale-125 transition-all duration-500 ease-out">
                        <h2 class="dark:text-white mt-8">{{ course.name }}</h2>
                    </div>
                    <div class="bg-grey absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 opacity-50 group-hover:opacity-75 flex flex-col justify-end items-center shrink-0 shadow rounded border-4 bg-center"
            [ngClass]="selectedCourseId === course.id ? 'border-red opacity-75' : 'border-white'">
            @if (course.price) {
            <img src="./assets/img/card-images/knoot_kaufbar.svg" class="w-14 mb-2" alt="Course Image">
            } @else {
            <ng-icon name="faSolidLock" class="w-12 mb-8 text-4xl text-blue dark:text-white"
                [ngClass]="{ 'dark:text-white': selectedCourseId !== course.id}"></ng-icon>
            }
        </div>
                </div>
            </a>
            }
            }
        </div>
    </div>

    @if (selectedCourse) {

    @if(selectedCourse.description){
    <div
        class="odd:bg-background even:bg-background-dark group w-full pt-6 pb-12 md:px-16 px-2 flex flex-col items-center">
        <div class="flex flex-col md:flex-row items-center md:items-start md:gap-4 max-w-screen-md">
            <div class="flex flex-col items-center">
                <h2 class="text-secondary text-2xl font-bold mb-2"> {{ selectedCourse.name }}</h2>
                <p class="mt-4">{{ selectedCourse.description }}</p>
                @if(selectedCourse.furtherInformationLink){
                <a class="hidden md:inline" [href]="selectedCourse.furtherInformationLink" target="_blank">
                    <button class="blue-button mt-4">Weitere Informationen</button>
                </a>
                }
            </div>
            @if(selectedCourse.topics) {
            <app-accordion class="mt-4 group-odd:bg-background-dark group-even:bg-background rounded-lg w-full">
                <app-accordion-item>
                    <div accordionTitle class="w-full text-center"><span>Themen</span></div>
                    <div accordionContent>
                        <ul class="space-y-3">
                            @for(topic of selectedCourse.topics.split(','); track $index){
                            <li>{{ topic.trim() }}</li>
                            }
                        </ul>
                    </div>
                </app-accordion-item>
            </app-accordion>
            }

        </div>
        @if(selectedCourse.furtherInformationLink){
        <a class="md:hidden" [href]="selectedCourse.furtherInformationLink" target="_blank">
            <button class="blue-button mt-4">Weitere Informationen</button>
        </a>
        }
    </div>
    }

    @if(hasBookDownloadAccess(selectedCourse)) {
    <div class="odd:bg-background even:bg-background-dark group w-full mt-6 pb-6 md:px-16 px-2 flex justify-center">
        <div class="w-full max-w-[460px] flex flex-col gap-4 rounded-[14px] px-5 pt-5 pb-4 text-[#f8fbff] bg-gradient-to-b from-[#072b53] to-[#294765] shadow-[0_10px_24px_rgba(5,20,38,0.25)]">
            <div class="flex flex-col gap-2">
                <p class="m-0 text-[0.66rem] font-bold tracking-[0.09em] uppercase text-[#c8d6e8]">Buch-Download</p>
                <h3 class="m-0 leading-tight text-white">Dein Buch-Download</h3>
                <p class="m-0 text-[#e0ebf8]">Du kannst dein gekauftes PDF-Buch jederzeit hier herunterladen.</p>
            </div>

            <div class="flex flex-col gap-3 rounded-2xl bg-white/5 p-3 sm:flex-row sm:items-center sm:justify-between">
                <button class="inline-flex w-full items-center justify-center rounded-full border border-white/20 bg-white/10 px-4 py-2 font-semibold text-white shadow-sm transition-transform transition-colors hover:-translate-y-0.5 hover:bg-white/20 sm:flex-1" (click)="downloadBook(selectedCourse)" type="button">
                    PDF herunterladen
                </button>
            </div>
        </div>
    </div>
    }

    @if(hasPurchaseOptions(selectedCourse)) {
    <div class="odd:bg-background even:bg-background-dark group w-full py-12 md:px-16 px-2 flex flex-col md:flex-row">
        <div class="w-full flex flex-col items-center gap-2 rounded-[14px] px-5 pt-5 pb-4 text-[#f8fbff] bg-gradient-to-b from-[#072b53] to-[#294765] shadow-[0_10px_24px_rgba(5,20,38,0.25)] m-0 w-full text-center text-white mx-auto"
            [ngClass]="{
                'max-w-[460px]': getPurchaseOptions(selectedCourse).length === 1,
                'max-w-[760px]': getPurchaseOptions(selectedCourse).length === 2,
                'max-w-[1100px]': getPurchaseOptions(selectedCourse).length >= 3
            }">
            <!-- PAYWALL! -->
            <h3 id="kaufoptionen" class="text-xl font-bold !text-white uppercase tracking-wide">Kaufoptionen <i
                    class="fa-solid fa-lock"></i></h3>
            <div class="w-full mt-2 grid gap-4 items-stretch" [ngClass]="{
                'md:grid-cols-1': getPurchaseOptions(selectedCourse).length === 1,
                'md:grid-cols-2': getPurchaseOptions(selectedCourse).length === 2,
                'md:grid-cols-3': getPurchaseOptions(selectedCourse).length >= 3
            }">
                @for(option of getPurchaseOptions(selectedCourse); track option.type) {
                <div class="rounded border p-4 flex flex-col items-center text-center gap-3 relative h-full" [ngClass]="option.type === 'bundle'
                        ? (option.disabled ? 'border-amber/70 shadow-lg ring-2 ring-amber/30 bg-white/10 opacity-60' : 'border-amber/70 shadow-lg ring-2 ring-amber/30 bg-white/10')
                        : (option.disabled ? 'border-white/30 bg-white/5 opacity-60' : 'border-white/30 bg-white/5')">
                    @if(option.type === 'bundle') {
                    <span
                        class="absolute -top-3 px-3 py-1 rounded-full bg-amber text-primary-hover border border-amber/80 text-xs font-bold uppercase tracking-wide shadow">
                        Empfehlung
                    </span>
                    }
                    <h4 class="font-bold text-white">{{ option.title }}</h4>
                    <p class="text-sm !text-white/90 leading-snug min-h-[3.5rem]">{{ option.description }}</p>

                    <div class="mt-auto w-full flex flex-col items-center gap-3">
                        <div class="font-bold text-lg"
                            [ngClass]="option.type === 'bundle' ? 'text-amber' : 'text-white'">{{ option.price |
                            number:'1.2-2':'de' }} €</div>
                        <div class="w-full flex flex-col gap-2 lg:flex-row lg:items-center">
                            <a class="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full border border-white/20 bg-white/10 px-4 py-2 font-semibold !text-white shadow-sm transition-transform transition-colors hover:-translate-y-0.5 hover:bg-amber hover:border-amber hover:!text-primary-hover"
                                [ngClass]="option.disabled ? 'opacity-60 pointer-events-none' : ''"
                                [routerLink]="option.disabled ? null : ['/purchase', selectedCourseId]"
                                [queryParams]="option.disabled ? null : { purchaseType: option.type }"
                                [attr.aria-disabled]="option.disabled ? 'true' : null">
                                {{ option.cta }}
                            </a>
                            @if(option.previewUrl && option.type != 'bundle') {
                            <div class="flex w-full items-center justify-center lg:w-auto">
                                <a class="inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/30 bg-white/10 p-3 text-xs font-semibold !text-white transition-colors hover:bg-white hover:!text-primary-hover lg:w-auto"
                                    [href]="option.previewUrl" target="_blank" rel="noopener noreferrer">
                                    <i class="fa-regular fa-eye"></i>
                                    Vorschau
                                </a>
                            </div>
                            }
                        </div>

                    </div>
                </div>
                }
            </div>
        </div>
    </div>

    } @else if (!selectedCourse.access) {
    <div class="odd:bg-background even:bg-background-dark group w-full py-12 md:px-16 px-2 flex flex-col md:flex-row">
        <div
            class="shadow-box flex flex-col items-center group-odd:bg-background-dark group-even:bg-background max-w-screen-sm mb-4">
            <h2 class="text-secondary text-2xl font-bold mb-2"> {{ selectedCourse.name }}</h2>
            <h3> Zugriff anfragen <i class="fa-solid fa-lock"></i></h3>
            <div class="mt-2">
                Um Zugang zu diesem Kurs zu erhalten wende dich bitte an unsere TN-Betreuung oder per Mail an
                <a href="mailto:info@knoot-academy.de">info&#64;knoot-academy.de</a>. <br>
                <p class="mt-4">Alternativ kannst du uns direkt über unser Kontaktformular kontaktieren:</p>
            </div>
            <a href="https://www.knoot-academy.de/kontakt" target="_blank" rel="noopener noreferrer" class="blue-button font-normal mt-3 mb-1 pt-[0.3rem] hover:bg-blue hover:text-white">zum
                Kontaktformular</a>
        </div>
    </div>
    }

    

    @if(selectedCourse.access){

    @if(selectedCourse.name === 'AISE I') {
<div class="odd:bg-background even:bg-background-dark w-full py-12 md:px-16 px-4">
    <div class="max-w-4xl mx-auto flex flex-col md:flex-row items-center md:items-start gap-8">

        <!-- Linke Spalte: Intro + CTA -->
        <div class="flex-1 flex flex-col items-center md:items-start text-center md:text-left">
            <i class="fa-solid fa-flask text-3xl text-blue dark:text-white mb-3"></i>
            <h2 class="text-secondary text-2xl font-bold mb-2">Beta-Test</h2>
            <p class="mb-4 max-w-md">
                Du hast Zugriff auf den Beta-Test für AISE I. Teste die neuen Funktionen und gib uns dein Feedback.
            </p>
            <a routerLink="/beta-test" class="blue-button hover:bg-blue hover:text-white flex items-center justify-center">
                Zum Beta-Test
            </a>
        </div>

        <!-- Rechte Spalte: Hinweise -->
        <div class="flex-1 bg-background dark:bg-background-dark border border-blue/20 rounded-lg p-5 text-left w-full max-w-md">
            <h3 class="font-bold text-secondary mb-3 flex items-center gap-2">
                <i class="fa-solid fa-circle-info text-secondary align-middle"></i>
                <span>Wichtige Hinweise</span>
            </h3>
            <ul class="space-y-3 text-sm">
                <li class="flex gap-2">
                    <span>
                        Dein Fortschritt wird lokal in deinem Browser gespeichert. Nutze für den gesamten Beta-Test
                        <strong>dasselbe Gerät und denselben Browser</strong>, damit dein Fortschritt erhalten bleibt.
                    </span>
                </li>
                <li class="flex gap-2">
                    <span>
                        Du kannst uns <strong>jederzeit</strong> Feedback geben – am liebsten wäre uns aber, wenn du es nach Abschluss des ersten Moduls tust (oder generell, wenn du fertig bist 😊).
                    </span>
                </li>
            </ul>
        </div>

    </div>
</div>
}


    @if(selectedCourse.achievements && selectedCourse.achievements.length > 0){
    <div class="odd:bg-background even:bg-background-dark w-full md:py-6 md:px-16 py-4 px-2">
        <h2 class="text-secondary text-base font-bold"> {{ selectedCourse.name }}</h2>
        <h2>Deine bisherigen Erfolge</h2>
        <div class="flex flex-row flex-nowrap overflow-x-auto font-shadow scrollbar overflow-y-hidden py-4 gap-12">
            <!-- <div class="absolute right-0 w-20 h-44 from-white-dark bg-gradient-to-l z-50"></div> -->
            @for(achievement of selectedCourse.achievements; track achievement.id){
            <div class="dark-shadow rounded shrink-0 w-44 h-44 flex flex-col justify-end text-center relative">
                <i class="fa-solid fa-award z-50 text-3xl text-blue dark:text-white mb-5 block mx-auto"></i>
                <h3 class="z-50 text-lg pb-6 dark:text-white">
                    @if(achievement.type === 'test-completions' && achievement.count === 1){
                    Prüfung {{ achievement.expand.exam?.name }} bestanden!
                    } @else if (achievement.type === 'test-completions') {
                    Prüfung {{ achievement.expand.exam?.name }} {{ achievement.count }}x bestanden!
                    } @else if (achievement.type === 'correct-streak') {
                    {{ achievement.count }} Fragen in der Reihe richtig!
                    }
                </h3>
                <div class="absolute w-44 h-44 flex text-center opacity-50 items-center rounded bg-center bg-primary opacity-[15%]"
                    ></div>
            </div>
            }
        </div>
    </div>
    }
    @if(selectedCourse.stats){
        <div class="odd:bg-background even:bg-background-dark group w-full pt-6 pb-12 md:px-16 px-2">
        <h2 class="text-secondary text-base font-bold"> {{ selectedCourse.name }}</h2>
        <div class="flex flex-row pb-2 gap-4 items-baseline">
            <h2>Gesamt</h2>
            <a [routerLink]="['/training', selectedCourse.id]" class="dark:text-white">
                Zum Trainingsbereich &#10141;
            </a>
        </div>
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-3 mt-4 pb-4 items-start">
            <app-stat-card
                class="group-odd:bg-background-dark group-even:bg-background rounded dark:border dark:border-grey"
                title="Durchgeführte Prüfungssimulationen" [value]="selectedCourse.stats.total.exams_taken" />
            <app-stat-card
                class="group-odd:bg-background-dark group-even:bg-background rounded dark:border dark:border-grey"
                title="Beantwortete Fragen" [value]="selectedCourse.stats.total.questions_answered" />
            @if(selectedCourse.stats.total.readiness_score != undefined){
            <app-stat-card
                class="group-odd:bg-background-dark group-even:bg-background rounded dark:border dark:border-grey"
                title="Prüfungsbereit (experimentell)"
                value="{{ selectedCourse.stats.total.readiness_score | number:'1.2-2'}}%"
                explainer="Die Prüfungsbereitschaft berechnet sich aus den Ergebnissen deiner letzten Prüfungssimulationen. Der errechnete Wert ist noch experimentell und sollte nicht als Bestehensgarantie verstanden werden." />
            } @else {
            <app-stat-card
                class="group-odd:bg-background-dark group-even:bg-background rounded dark:border dark:border-grey"
                title="Prüfungsbereit (experimentell)" value="Keine Daten"
                explainer="Du musst mindestens 5 Prüfungssimulationen abgeschlossen haben, damit wir deine Prüfungsbereitschaft vorhersagen können." />
            }
        </div>

        <h2 class="pb-2">Letzte 7 Tage</h2>
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-3 mt-4">
            <app-stat-card
                class="group-odd:bg-background-dark group-even:bg-background rounded dark:border dark:border-grey"
                title="Durchgeführte Prüfungssimulationen" [value]="selectedCourse.stats.last_7_days.exams_taken" />
            <app-stat-card
                class="group-odd:bg-background-dark group-even:bg-background rounded dark:border dark:border-grey"
                title="Beantwortete Fragen" [value]="selectedCourse.stats.last_7_days.questions_answered" />
            @if(selectedCourse.stats.last_7_days.avg_score != undefined){
            <app-stat-card
                class="group-odd:bg-background-dark group-even:bg-background rounded dark:border dark:border-grey"
                title="Durchschnittliches Ergebnis"
                value="{{ selectedCourse.stats.last_7_days.avg_score | number:'1.2-2'}}%"
                explainer="Das durchschnittliche Ergebnis aller in den letzten 7 Tagen durchgeführten Prüfungssimulationen in diesem Kurs." />
            } @else {
            <app-stat-card
                class="group-odd:bg-background-dark group-even:bg-background rounded dark:border dark:border-grey"
                title="Durchschnittliches Ergebnis" value="Keine Daten"
                explainer="Du hast in den letzten 7 Tagen keine Prüfungssimulationen abgeschlossen." />
            }
        </div>
    </div>
        }
    @if(selectedCourse.lastResults && selectedCourse.lastResults.length > 0){
    <div class="odd:bg-background even:bg-background-dark group w-full md:py-6 md:px-16 py-4 px-2">
        <h2 class="text-secondary text-base font-bold"> {{ selectedCourse.name }}</h2>
        <div class="flex flex-row pb-2 gap-4 items-baseline	">
            <h2>Deine letzten Ergebnisse</h2>
            <a [routerLink]="['/training', selectedCourse.id]" class="dark:text-white">
                Zum Trainingsbereich &#10141;
            </a>
        </div>
        @for(entry of selectedCourse.lastResults; track entry.date){
        <h3 class="pt-8 pb-2">{{ entry.date | date:'dd.MM.yyyy'}}</h3>
        <div class="flex flex-col gap-4">
            @for (result of entry.results; track result.id) {
            <!-- mobile -->
            <div
                class="md:hidden group-odd:bg-background-dark group-even:bg-background rounded p-4 flex lg:justify-between lg:flex-row flex-col flex-wrap dark:border dark:border-grey">
                <h3 class="lg:w-32 shrink-0">{{ result.title }} Prüfungssimulation</h3>
                <span>Durchgeführt um {{ result.startTime | date:'HH:mm' }} Uhr</span>
                <span>Benötigte Zeit: {{ result.timeTaken | date:'mm:ss'}} Minuten</span>
                <span class="lg:w-32 shrink-0">{{ result.score | number:'1.2-2' }}% bei {{ result.questionAmount }}
                    Fragen erreicht</span>
                <a class="pt-2" [routerLink]="['/evaluation', result.id]"><span>Ansehen</span></a>
            </div>

            <!-- desktop-->
            <div
                class="hidden md:flex group-odd:bg-background-dark group-even:bg-background rounded p-4 lg:justify-between lg:flex-row flex-col flex-wrap dark:border dark:border-grey">
                <span>{{ result.startTime | date:'HH:mm' }} Uhr</span>
                <span class="lg:w-32 shrink-0">{{ result.title }}</span>
                <span>{{ result.questionAmount }} Fragen</span>
                <span>Benötigte Zeit: {{ result.timeTaken | date:'mm:ss'}} Minuten</span>
                <span class="lg:w-32 shrink-0">{{ result.score | number:'1.2-2' }}% erreicht</span>
                <a [routerLink]="['/evaluation', result.id]"><span>Ansehen</span></a>
            </div>
            }
        </div>
        }
    </div>
    }

    }

    <div class="even:hidden bg-background h-8">

    </div>
    }
</div>